import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { FaPlay } from 'react-icons/fa';
import { HiX } from 'react-icons/hi';
import Navbar from "../components/navbar";
import heroImg from "../assets/images/hero-image.png";
import "./home.css";
import AboutSigiriya from "./about_sigiriya";
import FAQ from "./faq";
import Reviews from "./reviews";
import Partner from "./partner";
import LocationsSection from "./location";
import AboutUs from "./aboutus";
import Process from "./process";
import Footer from "./footer";

function Home() {
  const navigate = useNavigate();
  const [isTrailerOpen, setIsTrailerOpen] = useState(false);

  return (
    <div className="relative min-h-screen bg-[#fdf4e4] overflow-hidden">
      <Navbar />

      {/* Hero Section */}
      <div className="flex flex-col-reverse md:flex-row justify-between items-center px-6 md:px-20 pt-10 md:pt-10 pb-0 md:pb-0 gap-8 md:gap-0">
        {/* Left Side - Text Content */}
        <div className="text-center md:text-left flex flex-col justify-center md:justify-start gap-6 md:gap-8 md:w-3/5">
          <div>
            <h1 className="sigiriya-text font-mortend text-center leading-tight">
              SIGIRIYA VR
            </h1>
            <h2 className="exp-text font-ltremark text-center">
              EXPERIENCE HISTORY
            </h2>
          </div>

          <div className="flex justify-center md:justify-start gap-4 flex-wrap button-grp">
            <button
              onClick={() => navigate('/bookings/ekho')}
              className="bg-[#7c623f] text-white font-semibold py-2 px-6 rounded-full"
            >
              Book Now
            </button>

            <button
              onClick={() => navigate('/view360')}
              className="bg-[#3f3a32] text-white font-semibold py-2 px-6 rounded-full"
            >
              View 360
            </button>

            <button
              onClick={() => setIsTrailerOpen(true)}
              className="flex items-center gap-2 mt-2 md:mt-0"
            >
              <div className="w-6 h-6 border-2 border-black rounded-full flex items-center justify-center">
                <FaPlay className="text-[10px] text-black" />
              </div>
              <span className="text-sm md:text-base font-medium">
                Watch a trailer
              </span>
            </button>
          </div>
        </div>

        {/* Right Side - Image */}
        <div className="md:w-2/5 flex justify-center">
          <img src={heroImg} alt="VR Experience" className="hero-img" />
        </div>
      </div>

      {/* Trailer Modal */}
      {isTrailerOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-70 z-50 flex items-center justify-center px-4">
          <div className="relative w-full max-w-3xl bg-white rounded-xl overflow-hidden shadow-lg">
            {/* Close Button */}
            <button
              onClick={() => setIsTrailerOpen(false)}
              className="absolute top-2 right-3 text-2xl text-[#3f3a32] hover:text-[#7c623f] z-10"
            >
              <HiX />
            </button>

            {/* YouTube Video */}
            <div className="w-full h-[50vw] md:h-[400px]">
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/-N7CCHeRteQ?si=4h2P_OjDJGWCcWPB"
                title="Sigiriya VR Trailer"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      )}

      {/* Rest of the Page */}
      <div id="about" className="about-section">
  <AboutSigiriya />
</div>

<div id="locations" className="locations">
  <LocationsSection />
</div>

<div id="faq" className="faq-section">
  <FAQ />
</div>

<div id="reviews" className="reviews pt-12 p-3">
  <Reviews />
</div>

<div id="partner" className="partner py-8">
  <Partner />
</div>

<div id="aboutus" className="aboutus">
  <AboutUs />
</div>

<div id="process" className="process pt-16">
  <Process />
</div>

<div id="footer" className="footer">
  <Footer />
</div>

    </div>
  );
}

export default Home;
